import ViewItemsPage from '@/views/stocktake-app/ViewItemsPage.vue'
import ViewLoginPage from '@/views/stocktake-app/ViewLoginPage.vue'
import ViewStockController from '@/views/stocktake-app/ViewStockController.vue'

export default [
  {
    path: '/stocktake-app',
    name: 'stocktake-app',
    component: ViewLoginPage,
    meta: {
      group: 'stocktake',
      permissions: ['view-stocktake-app'],
      navigation: true,
    },
  },
  {
    path: '/stocktake-app/stockcontroller',
    name: 'stockcontroller',
    component: ViewStockController,
    meta: {
      group: 'stocktake',
      permissions: ['view-stock-controller'],
      navigation: true,
    },
  },
  {
    path: '/stocktake-app/stockitems/:depot?',
    name: 'stockitems',
    component: ViewItemsPage,
    meta: {
      group: 'stocktake',
      permissions: ['view-stocktake-app'],
      navigation: true,
    },
  },
]
